import * as R from "ramda";
import * as React from "react";
import { FaPlus } from "react-icons/fa";
import styled from "styled-components";

import { instructionType } from "../../../../../formatters/courseAuthor";
import { findLastChildComponentIndex } from "../../../../course-author/helpers/patches/util";
import { CourseComponentTag } from "../../../../course-author/types";
import ClickableElement from "../../../../utils/ClickableElement";
import { DraggableContainer, DraggablePlaceholder } from "../DraggableContainer.styles";
import { IInstructionalMaterialGroupProps } from "../types";
import { componentIndex } from "../util";
import { InstructionalItemsCol, InstructionalItemsRow } from "./Grid";
import InstructionDropTarget from "./InstructionDropTarget";
import InstructionItemWithDropTarget from "./InstructionItemWithDropTarget";
import { InstructionalItemRow } from "./InstructionListItem";
import { DropZone } from "../../../../../context/UseDragAndDrop";

const AddItemButton = styled(ClickableElement)`
  align-items: center;
  background: inherit;
  border: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  width: 100%;
  opacity: 0.5;
`;

const InstructionalMaterialGroup: React.SFC<IInstructionalMaterialGroupProps> = props => {
  const lastComponent = R.last(props.instructionalMaterials[props.instructionType]);
  const lastComponentIndex = lastComponent
    ? componentIndex(props.course, props.unitPath, lastComponent)
    : findLastChildComponentIndex(props.course, props.unitPath);

  const lastDropPosition =
    (R.isNil(lastComponentIndex) ? findLastChildComponentIndex(props.course, props.unitPath) : lastComponentIndex) + 1;

  return (
    <InstructionalItemsRow>
      <props.Icon />
      <InstructionalItemsCol>
        {props.instructionalMaterials[props.instructionType].map(InstructionItemWithDropTarget(props))}
        <DraggableContainer>
          <InstructionDropTarget
            editOperations={props.editOperations}
            dropPosition={lastDropPosition}
            path={props.unitPath}
            type={props.instructionType}
            alternateColor={false}
          />
          <DraggablePlaceholder height={3} />
          <DropZone
            dropPosition={lastDropPosition}
            dropZoneType="instruction"
            newInstructionType={props.instructionType}
            editOperations={props.editOperations}
            path={props.unitPath}
          >
            <InstructionalItemRow style={{ backgroundColor: props.bgColor }}>
              <AddItemButton
                onClick={props.editOperations.createComponent(
                  props.unitPath,
                  CourseComponentTag.Instruction,
                  props.instructionType
                )}
              >
                <FaPlus /> &nbsp; Add {instructionType(props.instructionType)} Slide
              </AddItemButton>
            </InstructionalItemRow>
          </DropZone>
        </DraggableContainer>
      </InstructionalItemsCol>
    </InstructionalItemsRow>
  );
};

export default InstructionalMaterialGroup;
